/*
 * ****************************************************************************
 * Copyright (C) 2018-2018, All rights reserved.
 * Project: chessmate
 * Created On: March 23rd, 2018
 * Last Modified: March 23rd, 2018
 * ****************************************************************************
 */

import * as React from 'react';
import * as Mui from 'mui';
import { GameStateContext } from 'contexts/gameStateContext';

/** GameHistoryProps - Properties */
export interface GameHistoryProps extends React.HTMLProps<HTMLDivElement> {
}

/** GameHistory */
export class GameHistory extends React.Component<GameHistoryProps> {
  constructor(props: GameHistoryProps, ctx: any) {
    super(props, ctx);
  }
  render() {
    const { ...props } = this.props;

    return (
      <GameStateContext>{game => (
        <div {...props}>
          <textarea className="fill" value={game.movesText()} readOnly />
        </div>
      )}</GameStateContext>
    );
  }
}

export default GameHistory;


// WEBPACK FOOTER //
// ./src/views/playChess/components/gameHistory.tsx